import axios from "axios";
const BASE_API_URL = process.env.REACT_APP_API_URL;
// =================Emp Education URL=====================
export const Get_All_Business_List = `${BASE_API_URL}/Business/Business_GetList`;
export const Get_All_Service_List = `${BASE_API_URL}/Service/Service_GetList`;
export const Get_All_Project_List = `${BASE_API_URL}/Project/Project_GetList`;
export const Get_Business_By_Id = `${BASE_API_URL}/Business/Business_GetBy_BusinessID`;
export const Get_Service_By_Id = `${BASE_API_URL}/Service/Service_GetBy_ServiceID`;
export const Get_Project_By_Id = `${BASE_API_URL}/Project/Project_GetBy_ProjectID`;
export const Get_Image_Gallery_List = `${BASE_API_URL}/Image/ImageGallery_GetList`;
export const Get_Image_Album_List = `${BASE_API_URL}/Image/ImageAlbum_GetList`;

export function getGallery() {
  return axios.get(Get_Image_Gallery_List);
}
export function getAlbums() {
 return axios.get(Get_Image_Album_List);
}

// ------------------------------
export function getBusinessList() {
  return axios.get(Get_All_Business_List);
}

export function getProjectList() {
  return axios.get(Get_All_Project_List);
}

export function getServiceList() {
  return axios.get(Get_All_Service_List);
}

// ------------------------------

export function getBusinessById(businessID) {
  return axios.post(Get_Business_By_Id, { businessID });
}

export function getProjectById(projectID) {
  return axios.post(Get_Project_By_Id, { projectID });
}

export function getServiceById(serviceID) {
  return axios.post(Get_Service_By_Id, { serviceID });
}
